import { BASE_URL_API } from "../../../constants";
import fetcher from "../../../utils/fetcher";

export const _api_get_documents_hr = (path_file = null) => {
    const params = path_file ? `?${path_file}` : "";
    return fetcher(`${BASE_URL_API}/documents/hr/files${params}`, {
        method: "GET",
        credentials: "include",
    });
};

export const _api_get_search_documents_hr = (path_file = null) => {
    const params = path_file ? `?${path_file}` : "";
    return fetcher(`${BASE_URL_API}/documents/search/hr${params}`, {
        method: "GET",
        credentials: "include",
    });
};

export const _api_get_search_documents_hr_leave = (path_file = null) => {
    const params = path_file ? `?${path_file}` : "";
    return fetcher(`${BASE_URL_API}/documents/search/leave${params}`, {
        method: "GET",
        credentials: "include",
    });
};

export const _api_get_search_documents_hr_common = (path_file = null) => {
    const params = path_file ? `?${path_file}` : "";
    return fetcher(`${BASE_URL_API}/documents/search/common${params}`, {
        method: "GET",
        credentials: "include",
    });
};

export const _api_get_search_documents_hr_timereporting = (
    path_file = null
) => {
    const params = path_file ? `?${path_file}` : "";
    return fetcher(`${BASE_URL_API}/documents/search/timesheet${params}`, {
        method: "GET",
        credentials: "include",
    });
};

export const _api_get_search_documents_hr_expenses = (path_file = null) => {
    const params = path_file ? `?${path_file}` : "";
    return fetcher(`${BASE_URL_API}/documents/search/expense_report${params}`, {
        method: "GET",
        credentials: "include",
    });
};

export const _api_get_documents_hr_common = (path_file = null) => {
    const params = path_file ? `?${path_file}` : "";
    return fetcher(
        `${BASE_URL_API}/documents/common_documents/files${params}`,
        {
            method: "GET",
            credentials: "include",
        }
    );
};

export const _api_get_documents_hr_leave = (path_file = null) => {
    const params = path_file ? `?${path_file}` : "";
    return fetcher(`${BASE_URL_API}/documents/leave/files${params}`, {
        method: "GET",
        credentials: "include",
    });
};

export const _api_get_documents_hr_expenses = (path_file = null) => {
    const params = path_file ? "?" + path_file : "";
    return fetcher(`${BASE_URL_API}/documents/expense/files${params}`, {
        method: "GET",
        credentials: "include",
    });
};

export const _api_get_documents_hr_timesheet = (path_file = null) => {
    const params = path_file ? "?" + path_file : "";
    return fetcher(`${BASE_URL_API}/documents/timesheet/files${params}`, {
        method: "GET",
        credentials: "include",
    });
};

export const _api_get_documents_hr_download_multiple = ({
    items = [],
    document_type = "",
}) => {
    return fetcher(
        `${BASE_URL_API}/documents/${document_type}/files/batch-download${items}`,
        {
            method: "GET",
            credentials: "include",
        }
    );
};

export const _api_get_employees = () => {
    return fetcher(`${BASE_URL_API}/documents/users/list`, {
        method: "GET",
        credentials: "include",
    });
};

export const _api_get_clients = () => {
    return fetcher(`${BASE_URL_API}/expense_report/client/list`, {
        method: "GET",
        credentials: "include",
    });
};

export const _api_get_budget_code = () => {
    return fetcher(`${BASE_URL_API}/documents/object_codes/list`, {
        method: "GET",
        credentials: "include",
    });
};

export const _api_get_categories = () => {
    return fetcher(`${BASE_URL_API}/documents/company_folder/list`, {
        method: "GET",
        credentials: "include",
    });
};

export const _api_get_documents_hr_delete_multiple = ({
    items = [],
    document_type = "",
}) => {
    return fetcher(
        `${BASE_URL_API}/documents/${document_type}/files/batch-delete${items}`,
        {
            method: "DELETE",
            credentials: "include",
        }
    );
};

export const _api_post_add_document = ({
    document_ids = [],
    folder = "",
    user_id = null,
}) => {
    return fetcher(`${BASE_URL_API}/documents/hr/files/add`, {
        method: "POST",
        body: JSON.stringify({
            document_ids,
            folder,
            user_id,
        }),
        credentials: "include",
    });
};
